<template>
  <div id="app" :class="[pageActive, 'page-prev-' + prevPageName, {'mobile' : mobile}]">
    <router-link
      @click.native="gaClickLogo"
      to="/"
      tag="div"
      class="logo"
      v-bind:class="classNameLogo"
      v-if="!mobile"
    >
      <Logo :mobile="mobile"></Logo>
    </router-link>
    <div class="contacts" v-if="!mobile">
      <!-- <a @click="gaClickPhone" href="tel:+7 495 227-90-11">+7 495 227-90-11</a> -->
      <!-- <br /> -->
      <a @click="gaClickEmail" href="mailto:hello@whynotgroup.ru">hello@whynotgroup.ru</a>
    </div>
    <!-- <router-view @classNameLogo="onClassNameLogo" v-show="loaded" /> -->
    <index @classNameLogo="onClassNameLogo" v-if="$route.name === 'Main' || mobile && loaded"></index>
    <detail
      @classNameLogo="onClassNameLogo"
      v-show="$route.name === 'Detail' && loaded || !rendered"
    ></detail>

    <preload></preload>

    <modal name="video" :width="'100%'" :height="'100%'">
      <button class="modal-close" @click="$modal.hide('video'); gaClickModalClose();"></button>
      <div class="video-frame">
        <iframe
          width="100%"
          height="100%"
          src="https://www.youtube.com/embed/9-WCjTmEukk?autoplay=1"
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>
    </modal>

    <YandexMetrikaPopup />
  </div>
</template>

<script>
import Preload from "@/components/Preload";
import Index from "@/components/Main";
import Detail from "@/components/Detail";
import Logo from "@/components/Logo";
import isMobile from "@/components/isMobile";
import YandexMetrikaPopup from "@/components/YandexMetrikaPopup";

export default {
    name: "App",
    data() {
        return {
            rendered: false,
            loaded: true,
            classNameLogo: null,
            prevPageName: "none",
            pageActive: null,
            mobile: false
        };
    },
    components: {
        Preload,
        Index,
        Detail,
        Logo,
        YandexMetrikaPopup
    },
    watch: {
        $route(to, from) {
            this.pageActive = `page-${this.$route.params.name}`;
            this.classNameLogo = null;
            if (from.params.name) {
                this.prevPageName = from.params.name;
            } else {
                this.prevPageName = "none";
            }
        }
    },
    methods: {
        onClassNameLogo(className) {
            if (className) {
                this.classNameLogo = className;
            } else {
                this.classNameLogo = null;
            }
        },
        gaClickLogo() {
            this.$gtm.trackEvent({
                event: "event",
                event_category: "wng_common",
                event_action: "click",
                event_label: "main"
            });
        },
        gaClickPhone() {
            this.$gtm.trackEvent({
                event: "event",
                event_category: "wng_common",
                event_action: "click",
                event_label: "tel"
            });
        },
        gaClickEmail() {
            this.$gtm.trackEvent({
                event: "event",
                event_category: "wng_common",
                event_action: "click",
                event_label: "email"
            });
        },
        gaClickModalClose() {
            this.$gtm.trackEvent({
                event: "event",
                event_category: "wng_btl",
                event_action: "click",
                event_label: "close_video1"
            });
        }
    },
    created() {
        this.pageActive = `page-${this.$route.params.name}`;
        if (isMobile()) {
            this.mobile = true;
        }
        if (!localStorage.getItem("visited")) {
            localStorage.setItem("visited", true);
            this.loaded = false;
        }
    },
    mounted() {
        this.rendered = true;
        window.onload = () => {
            this.loaded = true;
        };

        setTimeout(() => {
            this.loaded = true;
        }, 20000);
    }
};
</script>

<style src="@/styles/global.css">
</style>



// WEBPACK FOOTER //
// src/App.vue